/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoresListAliases {
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_SCORES = 'layout-scores',
  PANEL_TAB_CONTROL = 'panel-tab-control',
  SCORE_DINI_FRAGMENT = 'score-dini-fragment',
  SCORE_FLEX_FRAGMENT = 'score-flex-fragment',
  SCORE_MEWS_FRAGMENT = 'score-mews-fragment',
  SCORE_MORSE_FRAGMENT = 'score-morse-fragment',
  SCORE_NAS_FRAGMENT = 'score-nas-fragment',
  SCORE_NRS_FRAGMENT = 'score-nrs-fragment',
  SCORE_PEWS_FRAGMENT = 'score-pews-fragment',
  SCORE_TISS_28_FRAGMENT = 'score-tiss-28-fragment',
  TAB_CONTROL = 'tab-control',
  TAB_WITH_CONTENT_SCORE_DINI = 'tab-with-content-score-dini',
  TAB_WITH_CONTENT_SCORE_FLEX = 'tab-with-content-score-flex',
  TAB_WITH_CONTENT_SCORE_MEWS = 'tab-with-content-score-mews',
  TAB_WITH_CONTENT_SCORE_MORSE = 'tab-with-content-score-morse',
  TAB_WITH_CONTENT_SCORE_NAS = 'tab-with-content-score-nas',
  TAB_WITH_CONTENT_SCORE_NRS = 'tab-with-content-score-nrs',
  TAB_WITH_CONTENT_SCORE_PEWS = 'tab-with-content-score-pews',
  TAB_WITH_CONTENT_SCORE_TISS_28 = 'tab-with-content-score-tiss-28',
}
export { ScoresListAliases };
